<template lang="pug">
  div
    button.btn.btn-success.seltags-btn(v-if="!view_mode" type="button" @click="openModalSelTag" data-testid="btn-sel-tag") {{buttonName}}
    selected-tag(
      v-model="modalSelTag.selectedItems",
      :inputName="inputName",
      :view_mode="view_mode",
      @remove="removeSelectedTag"
    )
    modal-sel-tag(v-model="modalSelTag", @input="onChangeSelectedTags")
</template>

<script>
import SelectedTag from '@/components/molecules/SelectedTag'
import ModalSelTag from '@/components/organisms/ModalSelTag'

export default {
  name: 'SelTags',
  components: { SelectedTag, ModalSelTag },
  props: {
    value: {
      type: Array,
      default: function () { // selectedItems
        return []
      }
    },
    maxSelect: {type: Number, required: false, default: 100000},
    buttonName: {type: String, required: false, default: 'タグ選択'},
    inputName: {type: String, required: false, default: 'tags[]'},
    view_mode: {type: Boolean, required: false, default: false}, // 表示モード
    doReset: {type: Boolean, required: false, default: false}, // リセットフラグ
    mode: {
      type: Object,
      required: false,
      default: function () {
        return {
          isDispPv: true,
          canAddPv: true,
          isEdit: false
        }
      }
    }
  },
  data: function () {
    return {
      // タグ選択モーダル
      modalSelTag: {
        isOpen: false,
        selectedIds: [],
        selectedItems: [],
        mode: this.mode
      }
    }
  },
  watch: {
    value: function (newValue, oldValue) {
      this.initData()
    },
    doReset: function (newValue) {
      if (newValue) {
        this.initData()
      }
    }
  },
  created: function () {
    this.initData()
  },
  methods: {
    initData: function () {
      let items = []
      // 1件の場合arrayにする
      if (Array.isArray(this.value)) {
        items = this.value
      }
      else {
        if (this.value) {
          items = [this.value]
        }
      }

      // 初期化してから入れ直す
      this.modalSelTag.selectedItems = []
      this.modalSelTag.selectedIds = []

      for (let item of items) {
        this.modalSelTag.selectedItems.push(item)
        this.modalSelTag.selectedIds.push(item.id)
      }
    },
    /**
     * タグ選択ダイアログを開く
     * @param modalSelTag
     */
    openModalSelTag: function () {
      this.modalSelTag.isOpen = true
    },
    /**
     * 選択タグを解除する
     * @param modalSelTag
     */
    removeSelectedTag: function (index) {
      this.modalSelTag.selectedIds.splice(index, 1)
      this.modalSelTag.selectedItems.splice(index, 1)
      this.onChangeSelectedTags(this.modalSelTag)
    },
    onChangeSelectedTags: function (modalSelTag) {
      this.$emit(
        'input',
        // 単数選択の場合は配列じゃなくて1件そのものを返す
        this.maxSelect === 1 ? modalSelTag.selectedItems[0] : modalSelTag.selectedItems
      )
    }
  }
}
</script>

<style scoped>
.seltags-btn + .selected-box {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/SelTags.vue